export class ComposedReferralData {
  ibp: number | null = null;
  ibl: number | null = null;
  ibk: string | null = null;
  isOldPartnership?: boolean;
  lang?: string;
  page?: string;

  static isEqual(a: ComposedReferralData, b: ComposedReferralData) {
    if (!a && !b) {
      return true;
    }

    if (!a && b || a && !b) {
      return false;
    }

    if (a?.isOldPartnership !== b?.isOldPartnership) {
      return false;
    }

    const isEqualOrAbsentField = (key: keyof ComposedReferralData): boolean => {
      const fieldIsEqual = Boolean(a[key] && b[key] && a[key] === b[key]);
      const keyIsAbsent = !a[key] && !b[key];
      return keyIsAbsent || fieldIsEqual;
    }

    const keys: Array<keyof ComposedReferralData> = ['ibp', 'ibl', 'ibk', 'lang', 'page']

    return keys.every(isEqualOrAbsentField);
  }
}